export function computeHandleForBox(box, pointerX, pointerY, margin = 6) {
  const { x, y, width, height } = box;
  const nearLeft = Math.abs(pointerX - x) <= margin;
  const nearRight = Math.abs(pointerX - (x + width)) <= margin;
  const nearTop = Math.abs(pointerY - y) <= margin;
  const nearBottom = Math.abs(pointerY - (y + height)) <= margin;

  // Sarok zóna: 15px sugár a sarok körül
  const cornerRadius = 15;
  
  // Sarok távolságok számítása
  const distToTopLeft = Math.sqrt(Math.pow(pointerX - x, 2) + Math.pow(pointerY - y, 2));
  const distToTopRight = Math.sqrt(Math.pow(pointerX - (x + width), 2) + Math.pow(pointerY - y, 2));
  const distToBottomLeft = Math.sqrt(Math.pow(pointerX - x, 2) + Math.pow(pointerY - (y + height), 2));
  const distToBottomRight = Math.sqrt(Math.pow(pointerX - (x + width), 2) + Math.pow(pointerY - (y + height), 2));

  // Sarok detektálás - csak ha a sarok zónájában vagyunk
  if (distToTopLeft <= cornerRadius) return "top-left";
  if (distToTopRight <= cornerRadius) return "top-right";
  if (distToBottomLeft <= cornerRadius) return "bottom-left";
  if (distToBottomRight <= cornerRadius) return "bottom-right";

  // Edges - elsőbbséget kapnak a sarok zónán kívül
  if (nearLeft && pointerY >= y && pointerY <= y + height) return "left";
  if (nearRight && pointerY >= y && pointerY <= y + height) return "right";
  if (nearTop && pointerX >= x && pointerX <= x + width) return "top";
  if (nearBottom && pointerX >= x && pointerX <= x + width) return "bottom";

  // Inside
  const inside = pointerX > x && pointerX < x + width && pointerY > y && pointerY < y + height;
  if (inside) return "inside";
  return null;
}

export function computeFloorplanHandle(rect, pointerX, pointerY, margin = 6) {
  const box = {
    x: rect.x + (rect.floorplan_offset_x || 0),
    y: rect.y + (rect.floorplan_offset_y || 0),
    width: rect.floorplan_width || rect.width,
    height: rect.floorplan_height || rect.height,
  };
  return computeHandleForBox(box, pointerX, pointerY, margin);
}
